import { useTranslation } from 'react-i18next'

import Button from '../../Button'

import {
  CALENDAR_GRID_MODE_LABEL_KEY,
  QA_NAME_CALENDAR_GRID_MODE,
} from './CalendarGridModeButton.constants'

function CalendarGridModeButton({ isActive, mode, onChange }) {
  const { t } = useTranslation()

  function handleClick() {
    onChange(mode)
  }

  return (
    <Button.Outlined
      interactive={!isActive}
      isGrey={!isActive}
      qaName={QA_NAME_CALENDAR_GRID_MODE[mode]}
      text={t(CALENDAR_GRID_MODE_LABEL_KEY[mode])}
      onClick={handleClick}
    />
  )
}

export default CalendarGridModeButton
